import React from "react";
import styles from "./styles.module.css";
import Bootcamp from "./bootcamp";
import { Link } from "gatsby";

export const BOOTCAMPS_SECTION_ID = "bootcamps";

const Courses = ({ courses, mainPage }) => {
  return (
    <>
      <div className={styles.root}>
        <div>
          <section
            id={BOOTCAMPS_SECTION_ID}
            className={[styles.courseContainer, styles.profsContainer].join(
              " "
            )}
          >
            <div className={styles.courseCardDesc}>
              <div className={styles.subTitle}>
                <h2>Буткемпы</h2>
              </div>
              <p className={styles.desc}>
                {mainPage.mainDescProfessions.mainDescProfessions}
              </p>
            </div>

            <div id="profsColumns" className={styles.profsColumns}>
              {courses &&
                courses.map(({ node: course }, order) => (
                  <div className={styles.linkProf}>
                    <Link
                      className={styles.linkProf}
                      key={course.id}
                      to={`/${course.slug}`}
                    >
                      <Bootcamp {...course} startDay={order} />
                    </Link>
                  </div>
                ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};
export default Courses;
